import {extend} from 'vee-validate';

export default function () {
    //Cross reference does not work
/*    extend('subdomain', {
        params: ['domain'],
        message: (field, data) => {
            return`The ${field} - ${data[0]}.`},
        validate: (value, {domain}) => {

            if (value) {
                return new Promise(resolve => {
                    //validateSubdomain()
                    resolve({
                        valid: false,
                        data: ['Not this value']
                    })
                })
            }
            return true
        }
    });*/
}
